import React from 'react';
import Navigation from './lp2/Navigation';
import Footer from './lp2/Footer';

const AGB = () => {
    return (
        <div className="min-h-screen">
            <Navigation />
            
            <section className="py-20 px-4 bg-white">
                <div className="max-w-4xl mx-auto">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                            Allgemeine Geschäftsbedingungen (AGB)
                        </h1>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            Für EsGehtMirGut.ch - Der einfache Lebenszeichen-Service
                        </p>
                    </div>

                    <div className="prose prose-lg max-w-none">
                        <div className="bg-white rounded-lg shadow-sm border p-8">
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">1. Geltungsbereich</h3>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") regeln das Vertragsverhältnis zwischen Hanke Consulting (nachfolgend "Anbieter") und den Kunden (nachfolgend "Kunde") des Online-Dienstes EsGehtMirGut.ch, der unter der Webseite www.esgehtmirgut.ch zugänglich ist.
                            </p>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">2. Vertragsgegenstand</h3>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                Der Anbieter stellt dem Kunden einen Online-Dienst (nachfolgend "Service") zur Verfügung, der dem Kunden eine tägliche Kurznachricht schickt bzw. bei Nichtbeantwortung dieser Nachricht dann einer bei der Registrierung gemeldeten Kontaktperson eine Nachricht schickt. Der Service ist ausschliesslich für den persönlichen und nicht-kommerziellen Gebrauch bestimmt.
                            </p>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">3. Registrierung und Vertragsabschluss</h3>
                            <p className="text-gray-700 mb-4 leading-relaxed">
                                <strong>3.1.</strong> Für die Nutzung des Services ist eine Registrierung erforderlich. Mit der Registrierung erklärt sich der Kunde mit diesen AGB einverstanden und es kommt ein Vertragsverhältnis zustande.
                            </p>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                <strong>3.2.</strong> Der Kunde verpflichtet sich, bei der Registrierung wahre, aktuelle und vollständige Angaben zu machen und diese bei Änderungen umgehend zu aktualisieren.
                            </p>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">4. Leistungen und Verfügbarkeit</h3>
                            <p className="text-gray-700 mb-4 leading-relaxed">
                                <strong>4.1.</strong> Der Anbieter bietet den Kunden Zugang zum Dienst. Die genauen Leistungsmerkmale ergeben sich aus der jeweiligen Leistungsbeschreibung auf der Webseite.
                            </p>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                <strong>4.2.</strong> Der Anbieter bemüht sich um eine möglichst ununterbrochene Verfügbarkeit des Services, garantiert diese jedoch nicht. Insbesondere kann es zu Ausfallzeiten kommen, die für Wartungsarbeiten genutzt werden.
                            </p>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">5. Zahlungsbedingungen</h3>
                            <p className="text-gray-700 mb-4 leading-relaxed">
                                <strong>5.1.</strong> Der Service wird gegen eine monatliche Gebühr angeboten. Alle Preise verstehen sich inklusive der gesetzlichen Mehrwertsteuer.
                            </p>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                <strong>5.2.</strong> Die Zahlung der Gebühr erfolgt monatlich im Voraus. Der Kunde kann zwischen verschiedenen Zahlungsmethoden wählen, die auf der Webseite angeboten werden.
                            </p>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">6. Kündigung</h3>
                            <p className="text-gray-700 mb-4 leading-relaxed">
                                <strong>6.1.</strong> Das Vertragsverhältnis kann von beiden Seiten jederzeit mit einer Frist von 30 Tagen zum Ende eines Abrechnungszeitraums gekündigt werden.
                            </p>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                <strong>6.2.</strong> Das Recht zur ausserordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
                            </p>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">7. Haftung</h3>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                <strong>7.1.</strong> Der Anbieter haftet im Rahmen der gesetzlichen Bestimmungen für Vorsatz und grobe Fahrlässigkeit. Für leichte Fahrlässigkeit haftet der Anbieter nur bei Verletzung einer wesentlichen Vertragspflicht.
                            </p>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">8. Änderung der AGB</h3>
                            <p className="text-gray-700 mb-6 leading-relaxed">
                                Der Anbieter behält sich vor, diese AGB zu ändern. Über Änderungen wird der Kunde per E-Mail informiert. Widerspricht der Kunde den geänderten AGB nicht innerhalb von vier Wochen, gelten diese als akzeptiert.
                            </p>

                            <h3 className="text-2xl font-bold text-gray-900 mb-4">9. Schlussbestimmungen</h3>
                            <p className="text-gray-700 mb-4 leading-relaxed">
                                <strong>9.1.</strong> Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                <strong>9.2.</strong> Auf das Vertragsverhältnis findet ausschliesslich das Recht der Schweiz Anwendung. Gerichtsstand ist Zürich.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default AGB;




